export default {
  title: 'Aanbieding hernoemen',
  subtitle: 'Voer een nieuwe naam in voor uw aanbieding (maximaal 40 tekens)',
  toasts: {
    success: 'Aanbieding succesvol hernoemd',
    error: 'Hernoemen van aanbieding mislukt',
  },
  buttons: {
    rename: 'Hernoemen',
  },
  form: {
    title: {
      label: 'Naam aanbieding',
      placeholder: 'Naam aanbieding invoeren',
    },
  },
};
